"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-one/sections/list.tsx */

import { SmartImage } from "@/Components";
import { SmartLink } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type ListDivsItem = {
    key: Key | null | undefined;
    /** Detected variants: "Book Appointment" | "Talk to Doctors" | "Hospitals & Clinics" | "Healthcare" | "Medicine & Supplies" | "Lab Testing" */
    link0Text: ReactNode;
    /** Detected variants: "1s" | "1.5s" | "2s" | "2.5s" | "3s" | "3.5s" */
    dataWowDuration: string;
    /** Detected variants: "list-icon bg-secondary" | "list-icon bg-primary" | "list-icon bg-pink" | "list-icon bg-cyan" | "list-icon bg-purple" | "list-icon bg-orange" */
    className: string;
    /** Detected variants: "/Templates/Doccure/img/icons/list-icon-01.svg" | "/Templates/Doccure/img/icons/list-icon-02.svg" | "/Templates/Doccure/img/icons/list-icon-03.svg" | "/Templates/Doccure/img/icons/list-icon-04.svg" | "/Templates/Doccure/img/icons/list-icon-05.svg" | "/Templates/Doccure/img/icons/list-icon-06.svg" */
    src: string;
    /** Detected variants: "all_routes.booking" | "all_routes.doctorsGrid" | "all_routes.hospitals" | "all_routes.home3" | "all_routes.home13" | "all_routes.home12" */
    href: string;
    /** Detected variants: "list-item wow slideInDown" */
    link0ClassName?: string;
    /** Detected variants: "img" */
    alt?: string;
};
export type HomeOneListGeneratedProps = {
    /** Default: "4s" */
    divDiv0Div0Div0Div0H66Link0LinkDataWowDuration?: string;
    /** Default: "all_routes.home13" */
    divDiv0Div0Div0Div0H66Link0LinkHref?: string;
    /** Default: "img" */
    divDiv0Div0Div0Div0H66Link0Div0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/icons/list-icon-07.svg" */
    divDiv0Div0Div0Div0H66Link0Div0ImageWithBasePath0ImageSrc?: string;
    /** Default: "Home Care" */
    divDiv0Div0Div0Div0H66Link0H60H6Text?: ReactNode;
    h6H6Props?: Partial<ComponentProps<"h6">> | ((item: ListDivsItem) => Partial<ComponentProps<"h6">>);
    h6Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: ListDivsItem) => Partial<ComponentProps<typeof SmartLink>>);
    h6Link0Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: ListDivsItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    listDivs: ListDivsItem[];
    listDivsItemWrapper?: (item: ListDivsItem, content: ReactNode) => ReactNode;
    listDivsRenderer?: (defaultNode: ReactNode) => ReactNode;
    listDivsLinkVisible?: boolean;
    listDivsLinkRenderer?: (item: ListDivsItem, defaultNode: ReactNode) => ReactNode;
    listDivsImageVisible?: boolean;
    listDivsImageRenderer?: (item: ListDivsItem, defaultNode: ReactNode) => ReactNode;
    listDivsH6Visible?: boolean;
    listDivsH6Renderer?: (item: ListDivsItem, defaultNode: ReactNode) => ReactNode;
    listDivsLinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: ListDivsItem) => Partial<ComponentProps<typeof SmartLink>>);
    listDivsImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: ListDivsItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    listDivsH6Props?: Partial<ComponentProps<"h6">> | ((item: ListDivsItem) => Partial<ComponentProps<"h6">>);
};

const HomeOneListGenerated: FC<HomeOneListGeneratedProps> = ({
    divDiv0Div0Div0Div0H66Link0Div0ImageWithBasePath0ImageAlt = "img",
    divDiv0Div0Div0Div0H66Link0Div0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/icons/list-icon-07.svg",
    divDiv0Div0Div0Div0H66Link0H60H6Text = "Home Care",
    divDiv0Div0Div0Div0H66Link0LinkDataWowDuration = "4s",
    divDiv0Div0Div0Div0H66Link0LinkHref = "all_routes.home13",
    h6H6Props,
    h6Link0Div0ImageWithBasePath0ImageProps,
    h6Link0LinkProps,
    listDivs,
    listDivsItemWrapper,
    listDivsRenderer,
    listDivsLinkVisible,
    listDivsLinkRenderer,
    listDivsImageVisible,
    listDivsImageRenderer,
    listDivsH6Visible,
    listDivsH6Renderer,
    listDivsLinkProps,
    listDivsImageProps,
    listDivsH6Props,
}) => {
    return (
        <div className="list-section">
            <div className="container">
                <div className="list-card card mb-0 overflow-hidden">
                    <div className="card-body">
                        <div className="list-wraps">
                            {renderCollectionNode(
                                listDivs,
                                (item: ListDivsItem) => (
                                    renderItemNode(listDivsH6Visible, listDivsH6Renderer, item, (
                                        <h6 {...(typeof listDivsH6Props === "function" ? listDivsH6Props(item) : (listDivsH6Props ?? {}))} {...(typeof h6H6Props === "function" ? h6H6Props(item) : (h6H6Props ?? {}))} key={item.key}>
                                            {renderItemNode(listDivsLinkVisible, listDivsLinkRenderer, item, (
                                                <SmartLink href={item.href} className={item.link0ClassName ?? "list-item wow slideInDown"} data-wow-duration={item.dataWowDuration} {...(typeof listDivsLinkProps === "function" ? listDivsLinkProps(item) : (listDivsLinkProps ?? {}))} {...(typeof h6Link0LinkProps === "function" ? h6Link0LinkProps(item) : (h6Link0LinkProps ?? {}))}>
                                                    <div className={item.className}>
                                                        {renderItemNode(listDivsImageVisible, listDivsImageRenderer, item, (
                                                            <SmartImage src={item.src} alt={item.alt ?? "img"} {...(typeof listDivsImageProps === "function" ? listDivsImageProps(item) : (listDivsImageProps ?? {}))} {...(typeof h6Link0Div0ImageWithBasePath0ImageProps === "function" ? h6Link0Div0ImageWithBasePath0ImageProps(item) : (h6Link0Div0ImageWithBasePath0ImageProps ?? {}))} />
                                                        ))}
                                                    </div>
                                                    {item.link0Text}
                                                </SmartLink>
                                            ))}
                                        </h6>
                                    ))
                                ),
                                listDivsItemWrapper,
                                listDivsRenderer
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HomeOneListGenerated;
